"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Size = exports.CurrencyLabel = exports.Currency = exports.IconPosition = void 0;
require("@pulse-web-ui/tooltip");
require("react");
var IconPosition;
(function (IconPosition) {
    IconPosition["LEFT"] = "left";
    IconPosition["RIGHT"] = "right";
})(IconPosition = exports.IconPosition || (exports.IconPosition = {}));
var Currency;
(function (Currency) {
    Currency["RUB"] = "RUB";
    Currency["EUR"] = "EUR";
    Currency["USD"] = "USD";
})(Currency = exports.Currency || (exports.Currency = {}));
var CurrencyLabel;
(function (CurrencyLabel) {
    CurrencyLabel["RUB"] = "\u20BD";
    CurrencyLabel["EUR"] = "\u20AC";
    CurrencyLabel["USD"] = "$";
})(CurrencyLabel = exports.CurrencyLabel || (exports.CurrencyLabel = {}));
var Size;
(function (Size) {
    Size["Small"] = "s";
    Size["Medium"] = "m";
    Size["Large"] = "l";
})(Size = exports.Size || (exports.Size = {}));
